import React from "react"
import propTypes from "prop-types"
import { Card, CardBody, Row, Col, Button, Input, FormFeedback } from "reactstrap"

const EmailSelectorList = ({
  emails,
  isLoading,
  handleEmailChange,
  handleAddEmail,
  handleRemoveEmail,
  errors,
}) => {
  return (
    <Card className="mb-3">
      <CardBody className="p-3">
        {emails.map((email, index) => (
          <Row key={index} className={index > 0 ? "mt-3" : ""}>
            <Col md="10">
              <Input
                type="email"
                value={email}
                onChange={(e) => handleEmailChange(index, e.target.value)}
                placeholder="info@empresa.com"
                disabled={isLoading}
                invalid={!!(errors && errors[index])}
              />
              {errors && errors[index] ? (
                <FormFeedback>{errors[index]}</FormFeedback>
              ) : null}
            </Col>
            <Col md="2" className="d-flex justify-content-center">
              <Button
                color="danger"
                size="sm"
                onClick={() => handleRemoveEmail(index)}
                disabled={isLoading || emails.length === 1}
              >
                <i className="fa fa-trash" />
              </Button>
            </Col>
          </Row>
        ))}

        <Row className="mt-3">
            <Col md="12">
            <Button
              color="success"
              onClick={handleAddEmail}
              disabled={isLoading || emails.length >= 5}
            >
              <i className="fa fa-plus me-2" />
              Agregar otro correo
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

EmailSelectorList.propTypes = {
  emails: propTypes.array.isRequired,
  isLoading: propTypes.bool.isRequired,
  handleEmailChange: propTypes.func.isRequired,
  handleAddEmail: propTypes.func.isRequired,
  handleRemoveEmail: propTypes.func.isRequired,
  errors: propTypes.array,
}

export default EmailSelectorList
